/**
 * HPH Scroll Reveal
 * IntersectionObserver-based reveal animation.
 * Elements with .hph-reveal get .hph-reveal--visible when entering viewport.
 * Respects prefers-reduced-motion.
 */

(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('hph-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  function observe() {
    document.querySelectorAll('.hph-reveal:not(.hph-reveal--visible)').forEach((el) => {
      observer.observe(el);
    });
  }

  // Initial observation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  // Re-observe after Shopify section rendering (AJAX updates)
  document.addEventListener('shopify:section:load', observe);
})();
